module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAANCAYAAACZ3F9/AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQJJREFUeNpi+f//P8PEiRPXMjAw6ALxLwbCgA+Ie1mAmhYBGW5AbALEn4GYCY+m/0BsAMRbWICEOxBX5+fn32QgDjwFuRCk8Q0QM4NEgAJWUDYjkg1/gPgU0OC/SJr/sUAlf0AFaoGYFyrGADXgAxCHA/FXJI3MLFCGIIgAmupJpHPxBgQcAL3AiC4Gs/EDVMEGIMUP8gOaOkagHEisGOiqizCNLEgKqmEBhQPcg9I/QJqEgFgd6serRHpRHaSxGIgXAp0iD6QfATXnQZ29BEixYtEkCsQyjNAkZwHkxANxMhAvA2I5qD/vY9H4EYi7wBqRQq8BSNUDcQrQ5rn43AoQYABjBU14ycO9iQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/learning/task/comment.png
// module id = ePlp
// module chunks = 2